import axios from "axios";

export default {
//authenticate user route
authenticateUser: function(userData) {
    return new Promise((resolve, reject) =>{
        axios.post("/api/user/login", userData)
        .then(response => {
            resolve(response)
        })
        .catch(error => {
            reject(Error("failed to login error: " + error))
        })
    })

},
//logout user
logoutUser: function(userData) {
    return new Promise((resolve, reject) =>{
        axios.post("/api/user/logout", userData)
        .then(response => {
            resolve(response)
        })
        .catch(error => {
            reject(Error("failed to login error: " + error))
        })
    })

},
//register user route
registerUser: function(regData) {
    console.log('at API regsiter user front end')
    return new Promise((resolve, reject) => {
    axios.post("/api/user/register", regData)
    .then(response=>{
        if(response.data){
            resolve(response)
        }
        else{
            console.log('logon error')
        }
    })
    .catch(error=>{
        reject(Error("failed to register error: " + error))
    })
})
},
//register user route
getUsers: function() {
    return new Promise((resolve, reject) => {
    axios.get("/api/user/findAll")
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error("error: " + error))
    })
})
},
//submit News
submitNews: function(newsData){
    return new Promise((resolve, reject) => {
        axios.post("/api/news/createNews", newsData)
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
    })
},
//get News
getNews: function(){
return new Promise((resolve, reject) => {
    axios.get("/api/news/getNews")
.then(response=>{
    resolve(response)
})
.catch(error=>{
    reject(Error(error))
})
})
},
getNewsDetails: function(id){
    return new Promise((resolve, reject) => {
        axios.get("/api/news/getNews/" + id)
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
    })
},
//delete News
deleteNews: function(id){
    return new Promise((resolve, reject) => {
        axios.delete("/api/news/deleteNews/" + id)
    
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
})
},
getTopNews: function(){
    return new Promise((resolve, reject) => {
        axios.get("/api/news/getTopNews")
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
    })
},
//send text message
sendTextMessage: function(textData){
    return new Promise((resolve, reject) => {
        axios.post("/api/text/sendTextMessage/", textData)
    
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
})
},
//send email
sendEmail: function(emailData){
    return new Promise((resolve, reject) => {
        axios.post("/api/email/sendEmail/", emailData)
    
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        console.log(error)
        reject(Error(error))
    })
})
},
//send payment
sendPayment: function(paymentData){
    return new Promise((resolve, reject) => {
        axios.post("/api/payment/sendPayment/", paymentData)
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
           alert(error.response.data.message)
            reject(Error(error))
            
        })
    })
    },
submitFullRefund: function(paymentData){
      
        return new Promise((resolve, reject) => {
            axios.post("/api/payment/submitFullRefund/", paymentData)
            .then(response=>{
                resolve(response)
            })
            .catch(error=>{
               alert(error.response.data.message)
                reject(Error(error))
                
            })
        })
        },
//submit partial refund
submitPartialRefund: function(paymentData){

    return new Promise((resolve, reject) => {
        axios.post("/api/payment/submitPartialRefund/", paymentData)
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            alert(error.response.data.message)
            reject(Error(error))
            
        })
    })
    },   

//update complete order
updateCompleteOrder: function(id, status){   
    return new Promise((resolve, reject) => {
        axios.put("/api/completedOrders/updateCompleteOrder/" + id, status)
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            console.log('THIS IS THE ERROR FROM REFUND' + error)
            reject(Error(error))
        })
    })
    },

//submitMenuItem
submitMenuItem: function(menuData){
    return new Promise((resolve, reject) => {
        axios.post("/api/menu/createMenu/", menuData)
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            console.log(error)
            reject(Error(error))
        })
    })
    },
getMenu: function(){
    return new Promise((resolve, reject) => {
        axios.get("/api/menu/getMenu")
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
    })
    },
//delete Menu Item
deleteMenuItem: function(id){
        return new Promise((resolve, reject) => {
            axios.delete("/api/menu/deleteMenu/" + id)
        
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            reject(Error(error))
        })
    })
    },
//submitStoreItem
submitStoreItem: function(storeData){
    return new Promise((resolve, reject) => {
        axios.post("/api/store/createStore/", storeData)
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            console.log(error)
            reject(Error(error))
        })
    })
    },
getStore: function(){
    return new Promise((resolve, reject) => {
        axios.get("/api/store/getStore")
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
    })
    },
//delete Store Item
deleteStoreItem: function(id){
        return new Promise((resolve, reject) => {
            axios.delete("/api/store/deleteStore/" + id)
        
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            reject(Error(error))
        })
    })
    },

submitEvent: function(EventData){
        console.log('hmmm...')
        return new Promise((resolve, reject) => {
            axios.post("/api/events/createEvent", EventData)
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            reject(Error(error))
        })
        })
    },
getEvents: function(){
        return new Promise((resolve, reject) => {
            axios.get("/api/events/getEvents")
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            reject(Error(error))
        })
        })
    },
getEventDetails: function(id){
        return new Promise((resolve, reject) => {
            axios.get("/api/events/getEvents/" + id)
        .then(response=>{
            resolve(response)
        })
        .catch(error=>{
            reject(Error(error))
        })
        })
    },
getJobPosts: function(){
    return new Promise((resolve, reject) => {
        axios.get("https://carehawaii.isolvedhire.com/feeds/jobs_by_domain.xml", {
            "Content-Type": "application/xml; charset=utf-8"
        })
    .then(response=>{
        resolve(response)
    })
    .catch(error=>{
        reject(Error(error))
    })
    })
}



};
